var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "iframe-container" }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c("iframe", {
      staticClass: "iframe-content",
      attrs: { src: _vm.iframeSrc, frameborder: "0", scrolling: "auto" },
      on: { load: _vm.onIframeLoad }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dd11540", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd11540","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/trainResult.vue
// module id = 1760
// module chunks = 0